import { FC, ReactNode, useState } from 'react';
import { Collapse, Typography } from '@mui/material';

import { DropdownIcon } from '../DropdownIcon/DropdownIcon';

import { HeaderButton, Root } from './styled';

export interface ICollapsibleCardProps {
	className?: string;
	initialOpen?: boolean;
	title: string;
	icon?: ReactNode;
	content: ReactNode;
	renderTitle?: (title: string) => ReactNode;
}

const defaultRenderTitle = (title: string) => (
	<Typography variant="subtitle" color="primary.dark">
		{title}
	</Typography>
);

export const CollapsibleCard: FC<ICollapsibleCardProps> = ({
	className,
	initialOpen,
	title,
	content,
	icon,
	renderTitle = defaultRenderTitle,
}) => {
	const [isOpened, setIsOpened] = useState(initialOpen || false);

	const handleToggle = () => {
		setIsOpened((prev) => !prev);
	};

	return (
		<Root className={className}>
			<HeaderButton onClick={handleToggle} disableRipple>
				{icon && <div className="icon">{icon}</div>}
				<div className="title">{renderTitle(title)}</div>
				<div className="toggle">
					<DropdownIcon isOpened={isOpened} />
				</div>
			</HeaderButton>
			<Collapse className="content" unmountOnExit in={isOpened}>
				{content}
			</Collapse>
		</Root>
	);
};
